import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useState, useEffect } from "react";
import api from "@/lib/api";
import { TrialBanner } from "@/components/Trial";
import { useBrand } from "@/context/BrandContext";
import { Sidebar } from "@/components/layout/Sidebar";
import { TopBar } from "@/components/layout/TopBar";

const ROLE_BADGE = { admin: "role-admin", reviewer: "role-reviewer", readonly: "role-readonly" };

// Loads platform-admin flag and workspace white-label branding for the shell.
function useShellState(user, currentWorkspace) {
  const [isPlatform, setIsPlatform] = useState(false);
  const [brand, setBrand] = useState(null);
  useEffect(() => { if (user?.email) api.get("/platform/me").then((r) => setIsPlatform(!!r.data.is_platform_admin)).catch(() => {}); }, [user?.email]);
  useEffect(() => { if (currentWorkspace?.id) api.get(`/workspaces/${currentWorkspace.id}/branding`).then((r) => setBrand(r.data.white_label ? r.data : null)).catch(() => setBrand(null)); }, [currentWorkspace?.id]);
  return { isPlatform, brand };
}

export default function AppLayout() {
  const { user, workspaces, currentWorkspace, currentRole, switchWorkspace, logout } = useAuth();
  const navi = useNavigate();
  const [wOpen, setWOpen] = useState(false);
  const [mobileNav, setMobileNav] = useState(false);
  const { isPlatform, brand } = useShellState(user, currentWorkspace);
  const { brand: platform, logoSrc } = useBrand();
  const shell = { user, workspaces, currentWorkspace, currentRole, switchWorkspace, logout, navi, isPlatform, brand, platform, logoSrc, API_BASE: process.env.REACT_APP_BACKEND_URL, mobileNav, setMobileNav, wOpen, setWOpen, roleBadge: ROLE_BADGE[currentRole] };

  return (
    <div className="min-h-screen flex bg-[#0b0f17] text-slate-200">
      {mobileNav && <div className="fixed inset-0 z-40 bg-black/60 lg:hidden" onClick={() => setMobileNav(false)} data-testid="mobile-nav-overlay" />}
      <Sidebar {...shell} />
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar {...shell} />
        <TrialBanner workspaceId={currentWorkspace?.id} />
        <main className="flex-1 overflow-y-auto sf-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
